<template>
  <div>
    <b-tabs
      active-nav-item-class="rounded-top"
      :content-class="['card-border mb-4 px-4 py-4', { rounded: tabIndex !==0, 'rounded-right rounded-bottom': tabIndex === 0 }]"
      v-model="tabIndex"
      @activate-tab="onChangeTab">
      <b-tab title="Audits" />
      <b-tab title="Configurations">
        <div class="mb-4 px-3 pt-2 pb-2">
          <h1 class="h2 color-dark mb-0">{{ headerTitle }}</h1>
          <p class="m-0 text-muted">{{ headerText }}</p>
        </div>

        <CollectDataStep v-if="isDataStep" />
        <CollectCompetitorsStep v-else-if="configuration.status === 'searching_competitors' || configuration.status === 'choosing_competitors'" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { populateLocalStorage } from 'common/helpers'
import CollectDataStep from './form/collect_data_step'
import CollectCompetitorsStep from './form/collect_competitors_step'
import {
  subscribe, removeChannel, TAB_INDEX_KEY, LIMIT_COMPETITORS
} from './helpers'

export default {
  components: { CollectDataStep, CollectCompetitorsStep },
  data() {
    return {
      tabIndex: 1
    }
  },
  computed: {
    ...mapState(['configuration', 'basePath']),
    isDataStep() {
      return !this.configuration.id ||
        this.configuration.status === 'initialized' ||
        this.configuration.status === 'scheduled' ||
        this.configuration.status === 'disabled'
    },
    headerTitle() {
      return this.isDataStep ? (`${this.configuration?.id ? 'Edit' : 'New'} Audit configuration`) : 'Competitors'
    },
    headerText() {
      return this.isDataStep ?
        'First, set the audit parameters so that we can compile a list of competitors.' :
        `You can choose up to ${LIMIT_COMPETITORS} competitors.`
    }
  },
  created() {
    this.channel = subscribe('AuditReportsChannel', (msg) => {
      if (msg.event === 'audit_report_finished') {
        toastr.success('Audit successfuly completed.')
      }
    })
  },
  beforeDestroy() {
    removeChannel(this.channel)
  },
  methods: {
    onChangeTab(val) {
      if (val === 0) {
        populateLocalStorage({ [TAB_INDEX_KEY]: val })
        window.location.assign(this.basePath)
      }
    }
  }
}
</script>
